export default "__VITE_ASSET__CJ2HUc$2__"